
<template>
    <b-modal :no-close-on-backdrop="true" id="modal-property-tree" title="Search Service Category" hide-footer :centered="true" v-model="open">
        <b-form>
            <b-form-group label="" class="mt-0">
                <gofix-form-input class="p-color" label="Service Category" v-model="service" disabled required></gofix-form-input>
            </b-form-group>
            <div class="tree-scrollbar">
                <div class="contenAbsolute">
                    <div class="tree-view-properties">
                        <tree ref="tree" :data="treeData" :options="opts" @node:clicked="select">
                            <div slot-scope="{ node }" class="node-container"> {{ node.data.name }} </div>
                        </tree>
                    </div>
                </div>
            </div>
        </b-form>
        <b-button-group class="d-block text-right p-1rem">
            <gofix-button :disabled="$route.params.id != 0 && Item && (Item.status === 'Cancelled' || disabled)" label="APPLY" @click="applyData" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
</template>
<script>

import { mapGetters } from 'vuex';
import LiquorTree from 'liquor-tree'
export default {
    name: 'modal-service-category',
    components: {
        [LiquorTree.name]: LiquorTree,
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        contract_id: {
            type: Number,
            default: false
        },
        serviceSelected: {
            type: Object,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            open: false,
            service: null,
            treeData: [],
            rootId: null,
            selectedNode: null,
            opts: {
                minFetchDelay: 500,
                fetchData: (node) => {
                    node.isBatch = false;
                    if (node.data.id == this.rootId) {
                        return new Promise((resolve, reject) => {
                            resolve([]);
                        });
                    }
                    return new Promise((resolve, reject) => {
                        global.axios(`api/contracts/${this.contract_id}/tree-service-categories/${node.data.id}`, {
                                method: "GET",
                                headers: {
                                    Accept: "application/json",
                                }
                            })
                            .then(response => {
                                resolve(response.data.data);
                            })
                            .catch(error => reject(error));
                    });
                }
            },
            
        }
    },
    watch: {
        value: function (val) {
            if(val) {
                if(this.serviceSelected && this.serviceSelected.data && this.serviceSelected.data.node_path) 
                    this.service = this.serviceSelected.data.node_path;
            }
            this.open = val;
        },
        open: function (val) {
            this.$emit('input', val);
        },
        contract_id: function(val) {
            this.getData();
        }
    },
    computed: {
        ...mapGetters({
            Item: "CaseManagementController/Item",
        }),
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.rootId = null;
            this.treeData = [];
            if(!this.contract_id) return;
            return new Promise((resolve, reject) => {
                global.axios(`api/contracts/${this.contract_id}/tree-service-categories/0`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    })
                    .then(response => {
                        response.data.data[0].state = {
                            selected: true,
                            expanded: true
                        };
                        this.treeData = response.data.data
                        this.rootId = response.data.data[0].id;
                        resolve(response.data.data);
                    })
                    .catch(error => reject(error));
            });
        },
        select(node) {
            this.service = node.data.node_path;
            this.selectedNode = node.data;
        },
        applyData() {
            const node = Object.assign({}, this.selectedNode, {
                data: this.selectedNode
            });
            this.$emit('updateData', node)
            this.open = false;
        }
    }
}
</script>